import { TranslationMessages } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';

const messages: TranslationMessages =
{
	ra: {
		action: {
			delete: '刪除',
			show: '查看',
			list: '列表',
			open: '開啟',
			save: '儲存',
			create: '新建',
			edit: '編輯',
			sort: '排序',
			cancel: '取消',
			undo: '恢復',
			refresh: '刷新',
			add: '增加',
			remove: '刪除',
			add_filter: '增加條件',
			remove_filter: '移除條件',
			back: '退回',
			bulk_actions: '已選取 1 個項目 |||| 已選取 %{smart_count} 個項目',
			export: '輸出',
			search: '搜尋',
			clone: '複製',
			confirm: '確認',
			clear_input_value: '清除輸入內容',
			clear_array_input: '清除輸入陣列',
			create_item: '建立時間',
			select_all: '全選',
			select_row: '選擇列',
			select_columns: '選擇欄位',
			search_columns: '搜尋欄位', // 新增
			select_all_button: '全部選取', // 新增
			unselect: '取消選取',
			expand: '展開',
			close: '關閉',
			open_menu: '開啟選單',
			close_menu: '關閉選單',
			update: '更新',
			move_up: '上移',
			move_down: '下移',
			remove_all_filters: '清除所有條件',
			toggle_theme: '切換主題',
			update_application: '更新應用程式',
		},
		boolean: {
			true: '是',
			false: '否',
			null: ' '
		},
		page: {
			list: '%{name} 列表',
			edit: '%{name} #%{id}',
			show: '%{name} #%{id}',
			create: '新建 %{name}',
			dashboard: '總覽',
			not_found: '未發現',
			loading: '加載中',
			error: '出現錯誤',
			empty: '尚無 %{name} 的內容',
			invite: '是否要新增？',
			access_denied: '存取被拒絕',
			authentication_error: '驗證錯誤'
		},
		input: {
			file: {
				upload_several: '將多文件拖至此上傳，或點擊選取所有需要上傳的文件',
				upload_single: '將文件拖至此上傳, 或點擊這裡選取文件',
			},
			image: {
				upload_several: '將多圖片拖至此上傳，或點擊選取所有需要上傳的圖片',
				upload_single: '將圖片拖至此上傳, 或點擊這裡選取圖片',
			},
			references: {
				all_missing: '未找到參考數據.',
				many_missing: '至少有一條參考數據不再可用.',
				single_missing: '關聯的參考數據不再可用.',
			},
			password: {
				toggle_visible: '顯示',
				toggle_hidden: '隱藏'
			}
		},
		message: {
			yes: '是',
			no: '否',
			are_you_sure: '您確定?',
			about: '關於',
			not_found: '您輸入了錯誤的網址或者錯誤的鏈接.',
			loading: '頁面讀取中, 請稍候',
			invalid_form: '表單輸入無效. 請檢查錯誤提示',
			details: '詳細',
			delete_title: '刪除 %{name} #%{id}',
			delete_content: '您確定要刪除該項目?',
			error: "網頁錯誤，您的請求無法完成",
			bulk_delete_title: '刪除 %{name} |||| 刪除 %{smart_count}項 %{name} ',
			bulk_delete_content: '您確定要刪除 %{name}? |||| 您確定要刪除 %{smart_count} 項?',
			bulk_update_content: '您確定要更新 %{name}? |||| 您確定要更新 %{smart_count} 項?',
			bulk_update_title: '更新 %{name} |||| 更新 %{smart_count}項 %{name} ',
			unsaved_changes: '有一些更動還沒儲存，確定要取消掉嗎?',
			auth_error: '驗證錯誤',
			clear_array_input: '清除輸入陣列',
			access_denied: '存取被拒絕',
			authentication_error: '驗證錯誤',
			select_all_limit_reached: '已達到可選取的最大數量',
			placeholder_data_warning: '這是範例資料，請勿用於正式用途。',
		},
		navigation: {
			no_results: '結果為空',
			no_filtered_results: '沒有符合篩選條件的結果',
			clear_filters: '清除篩選條件',
			no_more_results: '頁碼 %{page} 超出末頁. 試試上一頁.',
			page_out_of_boundaries: '頁碼 %{page} 超出末頁',
			page_out_from_end: '已到最末頁',
			page_out_from_begin: '已到最前頁',
			page_range_info: '%{offsetBegin}-%{offsetEnd} / %{total}',
			page_rows_per_page: '每頁列數：',
			next: '下一頁',
			prev: '上一頁',
			skip_nav: '略過',
			partial_page_range_info: '部分頁面範圍資訊',
			current_page: '目前頁面',
			page: '頁',
			first: '第一',
			last: '最末',
			previous: '前',
		},
		sort: {
			sort_by: '依據 %{field} %{order} 排序',
			ASC: '升冪',
			DESC: '降冪',
		},
		auth: {
			user_menu: '設置',
			username: '用戶名',
			password: '密碼',
			email: '電子郵件',
			sign_in: '登錄',
			sign_in_error: '驗證失敗, 請重試',
			logout: '退出',
			auth_check_error: '請先登入後再繼續'
		},
		notification: {
			updated: '條目已更新 |||| %{smart_count} 項條目已更新',
			created: '條目已新建',
			deleted: '條目已刪除 |||| %{smart_count} 項條目已刪除',
			bad_item: '不正確的條目',
			item_doesnt_exist: '條目不存在',
			http_error: '與服務通信出錯',
			canceled: '取消動作',
			data_provider_error: 'dataProvider 錯誤. 請檢查 console 的詳細信息。',
			logged_out: '已登出，請重新登入',
			i18n_error: '沒有指定語言的翻譯資料。',
			not_authorized: '您沒有獲得存取此內容的授權。',
			application_update_available: '有可用的應用程式更新，請重新載入頁面。'
		},
		validation: {
			required: '必填',
			minLength: '最少 %{min} 個字',
			maxLength: '最多 %{max} 個字',
			minValue: '必須大於 %{min}',
			maxValue: '必須小於 %{max}',
			number: '必須為數字',
			email: '必須是有效的郵箱',
			oneOf: '必須為 %{options} 其中一項',
			regex: '必須符合指定的格式 (regexp): %{pattern}',
		},
        saved_queries: {
            label: '查詢標籤',
            query_name: '名稱',
            new_label: '建立條件標籤',
            new_dialog_title: '設定新條件標籤的名稱',
            remove_label: '刪除標籤',
            remove_label_with_name: '刪除『%{name}』條件標籤',
            remove_dialog_title: '刪除條件標籤',
            remove_message: '是否確定要刪除所選的條件標籤？',
            help: '協助',
        },
		configurable: {
            customize: '客製化',
            configureMode: '配置模式',
            inspector: {
                title: '標題',
                content: '內容',
                reset: '重置',
                hideAll: '全部隱藏',
                showAll: '全部顯示'
            },
            Datagrid: {
                title: '標題',
                unlabeled: '無名稱'
            },
            SimpleForm: {
                title: '標題',
                unlabeled: '無名稱'
            },
            SimpleList: {
                title: '標題',
                primaryText: '主要文字',
                secondaryText: '次要文字',
                tertiaryText: '最次文字'
            }
		}
	},
};

const i18nProvider = polyglotI18nProvider((locale) =>
{
	if(locale === 'zh-TW' || locale === 'zh')
		return messages;

	return englishMessages;
}, 'zh-TW');

export default i18nProvider;
